module.exports = __webpack_public_path__ + "img/Call-the-police.b8153bb7.png";